<template lang="pug">
    div(
        :data-gallery-id="albumId"
        class="yotpo yotpo-pictures-widget"
    )
</template>

<script>
import mixin from './mixin'

export default {
    mixins: [mixin],
    props: {
        albumId: {
            type: String,
            required: true,
        },
    },
}
</script>
